import React, { memo, useEffect, useMemo, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch } from 'react-redux';
import Fade from 'react-reveal/Fade';
import { useLocation, useNavigate } from 'react-router-dom';
import { postBotAnswerLike } from '../../../Store/actions/askclir.action';
import useShare from '../../../components/customHooks/useShare';
import { getLocalStorage, isMobileApp } from '../../../common/common';
import { toast } from 'react-toastify';
// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 *
 */
const DiagnosisAnswer = ({
  data,
  onRegenerate,
  showRegenarate = false,
  onRating,
  topicId = ''
}) => {
  // console.log('DiagnosisAnswer::', JSON.parse(getLocalStorage('user', '{}'))?.user_master_id);
  const naviagte = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isPublic = pathname?.includes('/share/openddx');
  const { question, answer, added_on, id, topic, rating } = data;
  const [questionText, setQuestionText] = useState('');
  const [user_rating, setRating] = useState(rating ? parseInt(rating) : -1);

  const [blinkingText, setBlinkingText] = useState(false);

  const [showRating, setShowRating] = useState(false);
  const [regenerateAnswer, setRegenerateAnswer] = useState(false);
  // const [user_id, set_user_id] = useState(JSON.parse(getLocalStorage('user', {}))?.user_master_id);
  function textIteratorFun(text, partLength) {
    let index = 0;
    return {
      next() {
        if (index >= text.length) {
          return { done: true };
        }
        const part = text.slice(index, index + partLength);
        index += partLength;
        return { value: part, done: false };
      }
    };
  }
  const getMOdifiedTopic = (text) => {
    if (!text) {
      return false;
    }
    let tempAnswer = text?.replace(/^\n+/, '').replace(/#+$/, '');
    let index = tempAnswer.indexOf('###'); // find the index of the first '#' character
    if (index !== -1) {
      tempAnswer = tempAnswer.substring(0, index); // extract the portion of the string before the '#' character
    }
    return tempAnswer;
  };

  const getMOdifiedAnswer = (text) => {
    return text?.replace(/^\n/, '');
  };

  useEffect(() => {
    let ratingShowTimeout = '';
    let btnShowTimeout = '';
    if (blinkingText) {
      if (ratingShowTimeout) {
        clearTimeout(ratingShowTimeout);
      }

      if (btnShowTimeout) {
        clearTimeout(btnShowTimeout);
      }

      if (!showRating) {
        btnShowTimeout = setTimeout(() => {
          setRegenerateAnswer(true);
        }, 5000);
        ratingShowTimeout = setTimeout(() => {
          setShowRating(true);
        }, 10000);
      }
    } else {
      console.log('blink if 1 ', showRating);
    }
    return () => {
      // setRegenerateAnswer(false);
      // setShowRating(false);
    };
  }, [blinkingText]);

  useEffect(() => {
    let intervalId = '';
    if (!answer) {
      return false;
    } else if (answer && !showRegenarate) {
      setBlinkingText(false);
      setQuestionText(answer);
      setShowRating(true);
    } else {
      let tempAnswer = '';
      // console.log('temp answer bef', answer);
      tempAnswer = answer?.replace(/^\n+/, '');
      // console.log('temp answer', tempAnswer);
      const iterator = textIteratorFun(tempAnswer, 10);
      let result = iterator.next();
      intervalId = setInterval(() => {
        if (result.done) {
          setBlinkingText(false);
          clearInterval(intervalId);
        } else {
          if (!blinkingText) {
            setBlinkingText(true);
          }
          setQuestionText((prevText) => prevText + result.value);
          result = iterator.next();
        }
      }, 100);
    }
    return () => {
      setBlinkingText(false);
      setQuestionText('');
      clearInterval(intervalId);
    };
  }, [answer]);

  const postrating = (answer_id, rating) => {
    if (user_rating > -1) {
      toast.warning('This Diagnosis is already rated once');
      return;
    }
    setRating(rating);
    /** comment for previous rating fixation */
    // if (onRating) {
    //   onRating();
    // }
    /** comment for previous rating fixation */

    dispatch(
      postBotAnswerLike({ answer_id, rating }, (res) => {
        onRating();
      })
    );
  };
  const share_url = useShare();
  const isStringLengthEqual = () => {
    if (questionText && answer) {
      return questionText?.length == answer?.length;
    } else {
      return false;
    }
  };

  const isEqual = useMemo(() => isStringLengthEqual(), [questionText, answer]);
  // console.log('demo:', isEqual, blinkingText, user_rating, questionText);
  const modifiedTopic = getMOdifiedTopic(topic);
  return (
    <>
      <div className="shadow mb-5 bg-white rounded-4 text-start">
        <div className="d-flex flex-column p-4 ">
          {!showRegenarate && modifiedTopic && (
            <p className="text-black fs-3 fw-semibold new-line ">
              {ReactHtmlParser(modifiedTopic)}
            </p>
          )}
          {questionText && (
            <div className={`text-black fs-4 new-line ${blinkingText ? ' blinking-cursor' : ''}`}>
              {ReactHtmlParser(questionText)}
            </div>
          )}

          {/* typewriter */}
        </div>

        {regenerateAnswer && showRegenarate && (
          <>
            <Fade bottom>
              <div className="d-flex flex-row mb-2 p-4 pb-0">
                <span className="fs-4">Didn't find something you liked?</span>
              </div>
              <div className="d-flex flex-row ms-sm-auto ms-0 p-4 mb-4">
                <a
                  onClick={onRegenerate}
                  className="ms-0 px-5 py-4 mt-3 mt-sm-0 rounded-4 fs-3 fw-semibold cursorPointer d-flex align-items-center justify-content-center magentaButton text-white flex-grow-1"
                >
                  Re-run DDx
                </a>

                <button
                  title="Reset Form"
                  className="fs-4 fw-semibold text-start d-flex align-items-center justify-content-center rounded-3 rounded-4 px-4 py-2 ms-4 cursorPointer rippleEffect resetBttn"
                  onClick={() =>
                    share_url(
                      topic,
                      `${process.env.REACT_APP_BASE_URL}#/share/${
                        isPublic ? 'openddx' : 'differential_diagnosis'
                      }/${topicId}`
                    )
                  }
                >
                  <svg
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-share fs-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                  </svg>
                </button>

                {/* <div
                  className="fs-4 text-start text-black bg-light d-flex align-items-center ms-4 justify-content-center rounded-4 px-4 py-2 border-light text-light cursorPointer d-inline-block yellowButton rippleEffect"
                  onClick={() =>
                    share_url(
                      topic,
                      isMobileApp()
                        ? 'https://doctor.clirnet.com/#/share/differential_diagnosis/' + id + '/'
                        : window.location.origin + '/#/share/differential_diagnosis/' + id + '/'
                    )
                  }
                >
                  <svg
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-share fs-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                  </svg>
                </div> */}
              </div>
            </Fade>
          </>
        )}
      </div>
      {showRating && !isPublic && (
        <Fade bottom>
          <div className="shadow mb-5 bg-white rounded-4 text-start d-flex flex-row align-items-center justify-content-center">
            <div className="fs-4">
              <span>Please rate the above DDx </span>
            </div>
            <div className="p-4 d-flex">
              <div className="replayRating">
                {[1, 2, 3, 4, 5].map((_rating, _index) =>
                  _rating <= user_rating ? (
                    <svg
                      key={_index + 1}
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-star-fill me-1 cursorPointer"
                      viewBox="0 0 16 16"
                      onClick={() => postrating(id, _rating)}
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                  ) : (
                    <svg
                      key={_index + 1}
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-star me-1 cursorPointer"
                      viewBox="0 0 16 16"
                      onClick={() => postrating(id, _rating)}
                    >
                      <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z" />
                    </svg>
                  )
                )}
              </div>
            </div>
          </div>
        </Fade>
      )}
      {showRating && isPublic && (
        <Fade bottom>
          <div className="d-flex flex-row ms-sm-auto ms-0 p-4 mb-4">
            <a
              onClick={() => naviagte('/')}
              className="ms-0 px-5 py-4 mt-3 mt-sm-0 rounded-4 fs-3 fw-semibold cursorPointer d-flex align-items-center justify-content-center bg-white flex-grow-1"
              style={{ color: '#000091' }}
            >
              Login to explore CLIRNET
            </a>
          </div>
        </Fade>
      )}
    </>
  );
};

DiagnosisAnswer.propTypes = propTypes;
DiagnosisAnswer.defaultProps = defaultProps;
// #endregion

export default memo(DiagnosisAnswer);
